import React, { useState } from 'react';
import { Modal } from './ui/Modal';
export function Footer() {
  const [activeModal, setActiveModal] = useState<'privacy' | 'terms' | null>(null);
  const openPrivacy = () => setActiveModal('privacy');
  const openTerms = () => setActiveModal('terms');
  const closeModal = () => setActiveModal(null);
  const currentYear = new Date().getFullYear();
  return <footer className="bg-[#FAF6F0] py-12 border-t border-[#3D2B1F]/10" data-id="element-23">
      <div className="max-w-4xl mx-auto px-4 text-center" data-id="element-24">
        {/* Links */}
        <div className="flex flex-wrap justify-center items-center gap-4 mb-8 text-sm font-medium" data-id="element-25">
          <button onClick={openPrivacy} className="text-[#3D2B1F]/70 hover:text-[#B8845C] transition-colors border-b border-transparent hover:border-[#B8845C]" data-id="element-26">
            Política de Privacidad
          </button>
          <span className="text-[#3D2B1F]/20" data-id="element-27">•</span>
          <button onClick={openTerms} className="text-[#3D2B1F]/70 hover:text-[#B8845C] transition-colors border-b border-transparent hover:border-[#B8845C]" data-id="element-28">
            Términos y Condiciones
          </button>
        </div>

        {/* Copyright & Disclaimer */}
        <div className="space-y-3 text-xs text-[#3D2B1F]/40" data-id="element-29">
          <p data-id="element-30">
            © {currentYear} El Plan 21 Días. Todos los derechos reservados.
          </p>
          <p data-id="element-31">
            Este sitio no es parte del sitio web de Facebook o Facebook Inc.
            Además, este sitio no está respaldado por Facebook de ninguna
            manera. FACEBOOK es una marca registrada de FACEBOOK, Inc.
          </p>
        </div>
      </div>

      {/* Privacy Modal */}
      <Modal isOpen={activeModal === 'privacy'} onClose={closeModal} title="Política de Privacidad" data-id="element-32">
        <div className="space-y-4 text-sm md:text-base" data-id="element-33">
          <p data-id="element-34">
            <strong data-id="element-35">Última actualización: {currentYear}</strong>
          </p>

          <h3 className="font-bold text-[#3D2B1F] text-lg mt-4" data-id="element-36">
            1. Recopilación de Información
          </h3>
          <p data-id="element-37">
            Respetamos su privacidad y nos comprometemos a protegerla. Cuando
            utiliza nuestro sitio web, podemos recopilar información personal
            que usted nos proporciona voluntariamente, como su nombre y
            dirección de correo electrónico al realizar una compra o suscribirse
            a nuestro boletín.
          </p>

          <h3 className="font-bold text-[#3D2B1F] text-lg mt-4" data-id="element-38">
            2. Uso de la Información
          </h3>
          <p data-id="element-39">
            La información que recopilamos se utiliza para procesar
            transacciones, enviar correos electrónicos periódicos con
            actualizaciones sobre su pedido o información relacionada con el
            producto, y mejorar nuestro servicio al cliente. No vendemos,
            intercambiamos ni transferimos a terceros sus datos personales.
          </p>

          <h3 className="font-bold text-[#3D2B1F] text-lg mt-4" data-id="element-40">
            3. Protección de Datos
          </h3>
          <p data-id="element-41">
            Implementamos una variedad de medidas de seguridad para mantener la
            seguridad de su información personal. Su información sensible se
            transmite a través de tecnología Secure Socket Layer (SSL) y luego
            se encripta en nuestra base de datos de proveedores de pasarelas de
            pago.
          </p>

          <h3 className="font-bold text-[#3D2B1F] text-lg mt-4" data-id="element-42">4. Cookies</h3>
          <p data-id="element-43">
            Utilizamos cookies para recordar y procesar los artículos en su
            carrito de compras y entender y guardar sus preferencias para
            futuras visitas. Puede elegir desactivar las cookies a través de la
            configuración de su navegador.
          </p>
        </div>
      </Modal>

      {/* Terms Modal */}
      <Modal isOpen={activeModal === 'terms'} onClose={closeModal} title="Términos y Condiciones" data-id="element-44">
        <div className="space-y-4 text-sm md:text-base" data-id="element-45">
          <p data-id="element-46">
            <strong data-id="element-47">Última actualización: {currentYear}</strong>
          </p>

          <h3 className="font-bold text-[#3D2B1F] text-lg mt-4" data-id="element-48">
            1. Aceptación de los Términos
          </h3>
          <p data-id="element-49">
            Al acceder y utilizar este sitio web y comprar nuestros productos
            digitales, usted acepta estar sujeto a estos términos y condiciones.
            Si no está de acuerdo con alguna parte de estos términos, no debe
            utilizar nuestros servicios.
          </p>

          <h3 className="font-bold text-[#3D2B1F] text-lg mt-4" data-id="element-50">
            2. Propiedad Intelectual
          </h3>
          <p data-id="element-51">
            Todo el contenido incluido en este sitio, como texto, gráficos,
            logotipos, imágenes y descargas digitales, es propiedad de "El Plan
            21 Días" y está protegido por las leyes de derechos de autor. La
            compra de nuestros productos digitales le otorga una licencia
            personal y no transferible para su uso. No está permitido compartir,
            revender o distribuir nuestros materiales.
          </p>

          <h3 className="font-bold text-[#3D2B1F] text-lg mt-4" data-id="element-52">
            3. Política de Reembolso
          </h3>
          <p data-id="element-53">
            Ofrecemos una garantía de satisfacción de 7 días. Si por alguna
            razón no está satisfecho con su compra, puede solicitar un reembolso
            completo dentro de los 7 días posteriores a la compra enviando un
            correo electrónico a nuestro soporte.
          </p>

          <h3 className="font-bold text-[#3D2B1F] text-lg mt-4" data-id="element-54">
            4. Limitación de Responsabilidad
          </h3>
          <p data-id="element-55">
            "El Plan 21 Días" no será responsable de ningún daño directo,
            indirecto, incidental o consecuente que resulte del uso o la
            imposibilidad de uso de nuestros materiales. El contenido se
            proporciona con fines educativos e informativos y no sustituye el
            consejo profesional médico o psicológico.
          </p>
        </div>
      </Modal>
    </footer>;
}